import React from 'react';
import { SunIcon, MoonIcon } from '@heroicons/react/24/outline';
import { useThemeMode } from '../../hooks/theme';
import type { ThemeMode } from '../../store/themeStore';

const MODES: {
  value: ThemeMode;
  label: string;
  Icon: React.ComponentType<{ className?: string }>;
}[] = [
  { value: 'light', label: 'Tema claro', Icon: SunIcon },
  { value: 'dark', label: 'Tema escuro', Icon: MoonIcon },
];

export const ThemeToggle: React.FC = () => {
  const { mode, setMode } = useThemeMode();

  return (
    <div
      className="flex items-center rounded-xl admin-border border dark:border-gray-600 bg-gray-50 dark:bg-gray-800 p-0.5"
      role="group"
      aria-label="Escolher tema"
    >
      {MODES.map(({ value, label, Icon }) => {
        const isActive = mode === value;
        return (
          <button
            key={value}
            type="button"
            onClick={() => setMode(value)}
            className={`p-2 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 dark:focus:ring-offset-gray-800 ${
              isActive
                ? 'bg-white dark:bg-gray-700 text-orange-500 shadow-sm dark:text-orange-400'
                : 'admin-text-muted hover:admin-text-body hover:bg-gray-100 dark:text-gray-400 dark:hover:text-gray-200 dark:hover:bg-gray-700'
            }`}
            aria-label={label}
            aria-pressed={isActive}
            title={label}
          >
            <Icon className="h-5 w-5" aria-hidden />
          </button>
        );
      })}
    </div>
  );
};
